<template>
    <modal v-model="show" :submit="add" :cancel="cancel" :disabled="!isSelected(item)" :title="title">

        <template slot="body" v-if="type === 'leaders'">
            <fg-input :label="$t('Username')" name="leader" required>
                <input-picker v-model="item" multiple :filter="leadersFilter" data-type="user" />
            </fg-input>
        </template>

        <template slot="body" v-else-if="type === 'members'">
            <fg-input :label="$t('Username')" name="members" required>
                <input-picker v-model="item" multiple :filter="membersFilter" data-type="user" />
            </fg-input>
        </template>

        <template slot="body" v-else-if="type === 'tags'">
            <fg-input :label="$t('Tags')">
                <el-select multiple
                           filterable
                           allow-create
                           class="select-primary"
                           size="medium"
                           v-model="item"
                           placeholder="Tags">
                    <el-option v-for="tag in tags"
                               class="select-primary"
                               :value="tag.title"
                               :label="tag.title"
                               :key="tag.title">
                    </el-option>
                </el-select>
            </fg-input>
        </template>

        <template slot="body" v-else-if="type === 'questionnaires'">
            <fg-input :label="$t('Questionnaires')" name="questionnaires" required>
                <input-picker v-model="item" multiple :filter="questionnairesFilter" data-type="questionnaire" />
            </fg-input>
        </template>

        <template slot="body" v-else-if="type === 'childTeams'">
            <fg-input :label="$t('Sub Teams')" name="childTeams" required>
                <input-picker v-model="item" multiple :filter="childTeamsFilter" data-type="team" />
            </fg-input>
        </template>

    </modal>
</template>

<script>
  import { Input, Button, Select, Option, Checkbox } from 'element-ui'
  import InputPicker from '../../Components/InputPicker'
  import Modal from '../../Components/BasicModal'
  import isEmpty from 'lodash/isEmpty'
  import findIndex from 'lodash/findIndex'

  export default {
    name: 'TeamModal',

    components: {
      [Input.name]: Input,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      InputPicker
    },
    props: {
      value: {
        type: Object
      },
      show: {
        type: Boolean
      },
      type: {
        type: String
      },
      cancel: {
        type: Function
      }
    },
    data () {
      return {
        item: {},
        title: '',
        tags: []
      }
    },
    methods: {
      leadersFilter: function (item) {
        return findIndex(this.value.leaders, v => v.user._id === item._id) === -1
      },
      membersFilter: function (item) {
        return findIndex(this.value.members, v => v.user._id === item._id) === -1
      },
      childTeamsFilter: function (item) {
        return this.value._id !== item._id && findIndex(this.value.childTeams, v => v._id === item._id) === -1
      },
      questionnairesFilter: function (item) {
        return findIndex(this.value.questionnaires, v => v._id === item._id) === -1
      },
      isSelected: function (item) {
        return !isEmpty(item)
      },
      add: function () {
        const {item, type} = this
        const newValue = this.value
        if (type === 'tags') {
          item.forEach(tag => {
            newValue.tags.push(tag)
          })
        } else if (type === 'questionnaires') {
          item.forEach(questionnaire => {
            newValue.questionnaires.push(questionnaire)
          })
        } else if (type === 'leaders') {
          item.forEach(leader => {
            newValue.leaders.push({ user: leader })
          })
        } else if (type === 'members') {
          item.forEach(member => {
            newValue.members.push({ user: member })
          })
        } else if (type === 'childTeams') {
          item.forEach(childTeam => {
            newValue.childTeams.push(childTeam)
          })
        }
        this.$emit('input', this.newValue)
        this.cancel()
      }
    },
    watch: {
      type (val) {
        switch (val) {
          case 'tags':
            this.title = this.$t('Add Tags')
            this.item = []
            break
          case 'questionnaires':
            this.title = this.$t('Add Questionnaire')
            this.item = []
            break
          case 'leaders':
            this.title = this.$t('Add Leaders')
            this.item = []
            break
          case 'members':
            this.title = this.$t('Add Members')
            this.item = []
            break
          case 'childTeams':
            this.title = this.$t('Add Sub Team')
            this.item = []
            break
          default:
            this.title = ''
            this.item = {}
            break
        }
      }
    }
  }
</script>